export function deepCopy<T>(source: T): T {
  return Array.isArray(source)
    ? source.map(item => deepCopy(item))
    : source instanceof Date
      ? new Date(source.getTime())
      : source && typeof source === 'object'
        ? Object.getOwnPropertyNames(source).reduce((o, prop) => {
          const descriptor = Object.getOwnPropertyDescriptor(source, prop);
          descriptor && Object.defineProperty(o, prop, descriptor);
          o[prop] = deepCopy((source as any)[prop]);
          return o;
        }, Object.create(Object.getPrototypeOf(source)))
        : source as T;
}